function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(cents / 100);
}

function updateCartDiscounts() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const container = document.getElementById('cart-discount-display');
      if (!container) return;

      const discounts = cart.cart_level_discount_applications;

      if (discounts && discounts.length > 0) {
        container.innerHTML = `
          <ul>
            ${discounts.map(discount => `
              <li>
                <div data-item="nav-text">Discount Code: ${discount.title}</div>
                <span data-item="nav-text" data-text-color="gray">
                  –<span class="money">${formatMoney(discount.total_allocated_amount)}</span>
                </span>
              </li>
            `).join('')}
          </ul>
        `;
      } else {
        container.innerHTML = '';
      }
    });
}

document.addEventListener('DOMContentLoaded', updateCartDiscounts);
document.addEventListener('theme:cart:updated', updateCartDiscounts);
